import { HomepageView } from '@/features/homepage/view/homepage-view';

export default HomepageView;
